import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Nav, Tab } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import {
  BreadLeftArrow,
  BreadRightArrow,
} from "../../../../SvgIconsData";
import { CloseIcon, CrownIcon} from "../../../../assets/icons/iconshere";
import DateRangeFilter from "../../../DateRangeFilter";
import ProPopup from "../../../layouts/ProPopup";
import UserReport from "./userReport";
import GroupReport from "./groupReport";

const Reports = () => {
  const [type, setType] = useState(0);
  const [dates, setDates] = useState({ start: null, end: null });
  const [dropdownGroupList, setDropdownGroupList] = useState([]);
  const [filter, setFilter] = useState([]);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [groupLoading, setGroupLoading] = useState(true);
  const [breadcrumbs, setBreadcrumb] = useState([]);
  const [activeTab, setActiveTab] = useState("groups");
  const options = [
    { value: "locationWiseCountReport", name: "Count Wise" },
    { value: "locationWiseIterationReport", name: "Iteration Wise" },
  ];
  const [userPlan, setUserPlan] = useState(null);
  const [openPro, setOpenPro] = useState(false);

  useEffect(() => {
    userPlan && !userPlan.report.group && setOpenPro(true);
  }, [userPlan]);

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  let index = breadcrumbs.findIndex((item) => item.uuid === userData.user.group.uuid);
  let itemsAfterMatch;
 
  if (index !== -1) {
    itemsAfterMatch = breadcrumbs.slice(index + 1);
  } 
  const getParents = async () => {
    try {
      let url = `${configData.config.UNO_URL}/api/bulk-actions/groupParent/${groupId}`;
      let { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      setBreadcrumb(data.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (event) => {
    if(event.value == "locationWiseCountReport" ){
      setType(0);
    }else if(event.value == "locationWiseIterationReport") {
      setType(1)
    }
  };

  useEffect(() => {
    if(userPlan?.report?.group){
      getParents();
    }
  }, [userPlan,type, groupId, dates]);

  return (
    <>
    <div className="container-fluid dashboard p-4 pt-2 pb-2 bg-grey-main">
      <div className="row mb-2">
        <div className="col-md-6 d-flex align-items-center justify-content-start mt-2">
          <div className="nav-btw">
            <span onClick={userData.user.group.uuid === groupId ? null : () => navigate(-1)}>
              <BreadLeftArrow />
            </span>
          </div>
          <div className="breadcrums">
            <span>
              <span onClick={() => navigate(`/reports/${userData.user.group.uuid}`)}>
                {userData.user.group.name}
              </span>
              {itemsAfterMatch?.length > 0 && <BreadRightArrow />}
            </span>
            {itemsAfterMatch?.length > 0 &&
              itemsAfterMatch.map((item, index) => {
                return (
                  <span
                    key={item.uuid}
                    className={item.uuid == groupId ? "active" : ""}
                    onClick={() => navigate(`/reports/${item.uuid}`)}>
                    <span>{item.name}</span>
                    {index !== itemsAfterMatch.length - 1 && <BreadRightArrow />}
                  </span>
                );
              })}
          </div>
        </div>
      </div>

      <Tab.Container activeKey={activeTab} id="my-tabs" defaultActiveKey="group">
        <div className="row">
          <div className="col-xl-4 d-flex align-items-center justify-content-start ">
            <Nav className="tabsproduct updated forreports" variant="tabs">
              
              <Nav.Item>
                <Nav.Link onClick={() => userPlan?.report?.user ? setActiveTab("groups") : setOpenPro(true) } eventKey="groups">
                  Group Wise {!userPlan?.report?.user && <CrownIcon  /> }
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link onClick={() => userPlan?.report?.user ? setActiveTab("users") : setOpenPro(true)} eventKey="users">
                     User Wise {!userPlan?.report?.user && <CrownIcon  /> }
                </Nav.Link>
                </Nav.Item>

            </Nav>
          </div>

          <div className="col-xl-8 d-flex align-items-center justify-content-end gap-2">
            {(activeTab === "groups" && userPlan?.report?.group) && (
              <>
                <div className="card flex justify-content-center prime-select">
                  <Dropdown
                    value={options[type].value}
                    onChange={(e) => handleChange(e)}
                    options={options}
                    optionLabel="name"
                    placeholder="Select a City"
                    className="w-full md:w-14rem"
                    style={{ minWidth: "10rem" }}
                  />
                </div>

                <div className="card flex justify-content-center prime-select">
                 {filter.length >0 &&
                  <span className="dselect" onClick={()=>setFilter([])}>
                    <CloseIcon/>
                  </span> }
                  <MultiSelect
                    loading={groupLoading ? true : false}
                    value={filter}
                    onChange={(item) => setFilter(item.value)}
                    options={dropdownGroupList}
                    optionLabel="name"
                    placeholder={groupLoading ? "Loading..." : "Select Groups"}
                    maxSelectedLabels={1}
                    className="w-full"
                    style={{ minWidth: "15rem" }}
                    filter
                  />
                </div>
                 
              </>
            )}

            <DateRangeFilter dates={dates} setDates={setDates} />
          </div>
        </div>

        <Tab.Content className="pt-0 ">

          <Tab.Pane eventKey="groups">
            <GroupReport dates={dates} type={type} groupId={groupId} typeName={options[type].value} filter={filter} setParentLoading={setGroupLoading} setDropdownGroupList={setDropdownGroupList} />
          </Tab.Pane>

          <Tab.Pane eventKey="users">
            <UserReport groupId={groupId} dates={dates} />
          </Tab.Pane>

        </Tab.Content>
      </Tab.Container>

    </div>
    <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default Reports;